module.exports = __webpack_public_path__ + "img/indicator_1.b0de6704.png";